import { usePromisedRequest } from "../Common/request";
import { resolveWithBody, resolveNoContent } from "./Utils/utils";

interface EligibleFeatureAnnouncementsResponse {
    eligibleKeys: string[];
}

export default {
    getEligibleFeatureAnnouncements(userId: number): Promise<EligibleFeatureAnnouncementsResponse> {
        return usePromisedRequest<EligibleFeatureAnnouncementsResponse>({
            url: `/api/users/${userId}/feature-announcements/eligible`,
            method: "get",
            json: true,
        }).then(resolveWithBody("Could not fetch eligible feature announcements."));
    },

    dismissFeatureAnnouncement(userId: number, featureKey: string): Promise<void> {
        return usePromisedRequest({
            url: `/api/users/${userId}/actions/dismiss-feature-announcement`,
            method: "put",
            json: { featureKey },
        }).then(resolveNoContent("Could not dismiss feature announcement."));
    },
};
